"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div.attrs(function (_a) {
    var isLink = _a.isLink, hasTooltip = _a.hasTooltip;
    return ({
        style: {
            cursor: (isLink || hasTooltip) ? 'pointer' : 'default'
        }
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n\n  .Link__tooltipWrapper {\n    align-items: center;\n    display: inline-flex;;\n    height: 40px;\n    justify-content: center;\n    width: 40px;\n  }\n\n  .Link__icon {\n    height: auto;\n    max-height: 40px;\n    max-width: 40px;\n    width: auto;\n  }\n"], ["\n  align-items: center;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n\n  .Link__tooltipWrapper {\n    align-items: center;\n    display: inline-flex;;\n    height: 40px;\n    justify-content: center;\n    width: 40px;\n  }\n\n  .Link__icon {\n    height: auto;\n    max-height: 40px;\n    max-width: 40px;\n    width: auto;\n  }\n"])));
var templateObject_1;
